import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import PermDataSettingIcon from '@mui/icons-material/PermDataSetting';
import FolderIcon from '@mui/icons-material/Folder';
import SourceIcon from '@mui/icons-material/Source';
import AssessmentIcon from '@mui/icons-material/Assessment';
import InsightsIcon from '@mui/icons-material/Insights';
import EditNoteIcon from '@mui/icons-material/EditNote';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import FeedbackIcon from '@mui/icons-material/Feedback';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import StudioSettingsIcon from '@mui/icons-material/SettingsApplications';
import { useHistory } from 'react-router-dom';
import useSideDrawerStyles from './SideDrawerStyles';
import { useTenant } from './components/tenantContext/TenantContext';
import { filterDashboardTabs } from './utils/moduleSwitcherUtils';

export default function SideDrawer({ loginPermissions }) {
  const [isOpened, setIsOpened] = React.useState(false);
  const history = useHistory();
  const classes = useSideDrawerStyles({ isOpened });

  const { tenant, setTenant } = useTenant();
  const { tenantName } = tenant;
  const navigationTabs = filterDashboardTabs(tenant.tabDetails, tenant);

  const toggleDrawer = () => {
    setIsOpened(!isOpened);
  };

  const handleNavigation = ({ path, tabTitle, tabUrl, forceRedirect }) => {
    setTenant((prev) => ({ ...prev, currentTabName: tabTitle || tabUrl }));
    setIsOpened(false);
    if (forceRedirect) {
      history.push({
        pathname: `/berlin/${tenantName}${path}`
      });
      return;
    }
    history.push(`/aiadmin/${tenantName}${path}`);
  };

  const checkPermissions = (checkList) => {
    if (!checkList?.length) return true;
    if (loginPermissions && loginPermissions.length > 0) {
      return checkList.some((permission) => loginPermissions.includes(permission));
    }
    return false;
  };

  return (
    <>
      <Tooltip title={isOpened ? 'Close Menu' : 'Open Menu'} placement="bottom">
        <IconButton onClick={toggleDrawer} className={`${classes.hamburgerButton} pm-side-drawer-toggle`}>
          {isOpened ? <ChevronLeftIcon /> : <MenuIcon />}
        </IconButton>
      </Tooltip>

      <Drawer variant="permanent" open={isOpened} classes={{ paper: classes.drawerPaper }}>
        <Box className={classes.listContainer}>
          <List>
            <Tooltip title="Dashboard" placement="right">
              <ListItem
                disablePadding
                onClick={() => {
                  setTenant((prev) => ({ ...prev, currentTabName: '' }));
                  history.push(`/aiadmin/${tenant.tenantName}`);
                  setIsOpened(false);
                }}
                className={classes.listItem}
              >
                <ListItemButton className={classes.listItemButton}>
                  <ListItemIcon className={classes.listItemIcon}>
                    <SpaceDashboardIcon />
                  </ListItemIcon>
                  <ListItemText primary="Dashboard" className={classes.listItemText} />
                </ListItemButton>
              </ListItem>
            </Tooltip>

            {navigationTabs.map((item) =>
              checkPermissions(item?.permissionsRequired) ? (
                <Tooltip key={item.tabName} title={!isOpened ? item.tabName : ''} placement="right">
                  <ListItem disablePadding onClick={() => handleNavigation(item)} className={classes.listItem}>
                    <ListItemButton className={classes.listItemButton}>
                      <ListItemIcon className={classes.listItemIcon}>
                        {item.toolTipTitle === 'chatUtility.AUDIT_LOG' && <SourceIcon />}
                        {item.toolTipTitle === 'chatUtility.USER_FEEDBACK' && <FeedbackIcon />}
                        {item.toolTipTitle === 'chatUtility.TRENDS_INSIGHTS' && <TrendingUpIcon />}
                        {item.toolTipTitle === 'chatUtility.CONFIGURATIONS' && <PermDataSettingIcon />}
                        {item.toolTipTitle === 'chatUtility.SUMMARY_QUIZ_MANANGEMENT' && <FolderIcon />}
                        {item.toolTipTitle === 'chatUtility.LLM_EVALUVATION' && <AssessmentIcon />}
                        {item.toolTipTitle === 'chatUtility.REPORTS' && <InsightsIcon />}
                        {item.toolTipTitle === 'chatUtility.PROMPT_MANANGEMENT' && <EditNoteIcon />}
                        {item.toolTipTitle === 'chatUtility.AIADMIN_USERS' && <ManageAccountsIcon />}
                        {item.toolTipTitle === 'chatUtility.INGESTION' && <LibraryBooksIcon />}
                        {item.toolTipTitle === 'chatUtility.BERLIN_STUDIO' && <StudioSettingsIcon />}
                      </ListItemIcon>
                      {isOpened && <ListItemText primary={item.tabName} className={classes.listItemText} />}
                    </ListItemButton>
                  </ListItem>
                </Tooltip>
              ) : null
            )}
          </List>
        </Box>
      </Drawer>
    </>
  );
}

SideDrawer.propTypes = {
  loginPermissions: PropTypes.array.isRequired
};
